import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'

@Component({
  selector: 'basin-formly-input-with-selector',
  templateUrl: './formly-input-with-selector.component.html',
  styleUrls: [],
})
export class FormlyInputWithSelectorComponent extends FieldType {}
